<template>
    <aside class="sf__foam-only-notice" aria-labelledby="sf-foam-only-heading">
        <svg class="sf__foam-only-notice__icon" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
            <path d="M17.7096 10C17.7096 14.2572 14.2585 17.7083 10.0013 17.7083C5.74411 17.7083 2.29297 14.2572 2.29297 10C2.29297 5.74281 5.74411 2.29167 10.0013 2.29167C14.2585 2.29167 17.7096 5.74281 17.7096 10Z" stroke-width="1.25" stroke="black"/>
            <path d="M10 9.16667V13.75" stroke-width="1.25" stroke-linecap="round" stroke="black"/>
            <path d="M10.0013 7.29167C10.4615 7.29167 10.8346 6.91857 10.8346 6.45833C10.8346 5.9981 10.4615 5.625 10.0013 5.625C9.54106 5.625 9.16797 5.9981 9.16797 6.45833C9.16797 6.91857 9.54106 7.29167 10.0013 7.29167Z" fill="black"/>
        </svg>
        <div class="sf__foam-only-notice__content">
            <h2 id="sf-foam-only-heading">{{ heading }}</h2>
            <p>{{ description }}</p>
            <a :href="linkUrl">{{ linkLabel }}</a>
        </div>
    </aside>
</template>

<script>
import {getFilterAppMessage} from '../helpers/filterAppMessages';

export default {
    props: ['vehicleParams'],

    computed: {
        heading() {
            return getFilterAppMessage('foamOnlyHeading').replace(/\[(Year|Make|Model)\]/g,
                (token, key) => this.vehicleParams?.[key.toLowerCase()] || '');
        },
        description() { return getFilterAppMessage('foamOnlyDescription'); },
        linkLabel() { return getFilterAppMessage('foamOnlyLinkLabel'); },
        linkUrl() { return getFilterAppMessage('foamOnlyLinkUrl'); }
    }
};
</script>
